import styled from '@emotion/styled';
import { FC } from 'react';

type Props = {
  className?: string;
};

const Header: FC<Props> = ({ className, children }) => {
  return <Root className={className}>{children}</Root>;
};

const Root = styled('div')(`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 36px;
`);

export default Header;
